import React, { useEffect } from 'react';
import { pageTitle } from '../PageTitle';
import HeaderOne from '../Header/HeaderTwo';
import FooterOne from '../Footer/FooterTwo';
import AboutOne from '../HomeOne/AboutOne/AboutOne';
import Choose from '../HomeOne/Choose/Choose';
import { Link } from 'react-router-dom';

import shape4 from "../../assets/images/shapes/shape-03.png";
import team1 from "../../assets/images/resource/team-01.png";
import team2 from "../../assets/images/resource/team-02.png";
import team3 from "../../assets/images/resource/team-03.png";
import team5 from "../../assets/images/resource/team-05.png";
import partners1 from "../../assets/images/resource/partners-01.png";
import team4 from "../../assets/images/resource/team-04.png";
import Pride from '../HomeThree/Pride/Pride';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { useLocation } from 'react-router-dom';
import Gallery from '../HomeOne/Gallery/Gallery';


const About = () => {
    const location = useLocation();

    useEffect(() => {
        const { hash } = location;
        if (hash) {
            const id = hash.slice(1);
            const element = document.getElementById(id);
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, [location]);

    pageTitle('About Us');
    const teamData = [
        {
            id: 1,
            name: 'Dr. Satish Chimakurthi, Ph.D.',
            role: "Founder & President",
            image: team1,
            data_aos_delay: '00ms',
            linkedin: "https://www.linkedin.com/in/satish-chimakurthi-ph-d-97482814"
        },
    ];

    const formerTeamData = [
        {
            id: 1,
            name: 'Sumanth Bejugam, MS',
            image: team2,
            data_aos_delay: '00ms',
            role: "Former Developer",
            linkedin: "https://www.linkedin.com/in/bejugamsumanth/"
        },
        {
            id: 2,
            name: 'Ronen Aniti, BS',
            image: team3,
            data_aos_delay: '100ms',
            role: "Former Applied Research Engineer",
            linkedin: "https://www.linkedin.com/in/ronen-aniti/"
        },
        {
            id: 3,
            name: 'Abhinav Chakravarthy',
            image: team5,
            data_aos_delay: '200ms',
            role: "Former Intern",
            linkedin: "https://www.linkedin.com/in/abhinav-chakravarthy-230713282"
        },
    ];

    const partnersData = [
        {
            id: 1,
            name: 'Mineral\'s MammothHR Solutions',
            role: "Human Resources",
            linkedin: "https://trustmineral.com/products/mammothhr/",
            image: partners1,
            data_aos_delay: '200ms',
        },
        {
            id: 2,
            name: 'LegalZoom',
            role: "Legal",
            linkedin: "https://www.legalzoom.com/",
            image: team4,
            data_aos_delay: '300ms',
        },
    ]

    return (

        <>
            <HeaderOne></HeaderOne>
            {/* <BreadCrumb></BreadCrumb> */}
            <AboutOne></AboutOne>
            <Choose></Choose>

            <section id="certifications" className="certifications see__pad p_relative">
                <div className="auto-container">
                    <div className="title__data">
                        <div className="sub__title">
                            <h4>Certifications</h4>
                        </div>
                        <div className="title">
                            <h2>Business Credentials</h2>
                        </div>
                    </div>
                    <div className="certifications__panel wow fadeInUp animated" data-wow-delay="100ms" data-wow-duration="1500ms">
                        <div className="certifications__badge">Virginia SWaM</div>
                        <h3>Small, Women-owned, and Minority-owned Business (SWaM)</h3>
                        <p>
                            Epitome Research &amp; Innovations Inc. is certified under the Commonwealth of
                            Virginia&apos;s <strong>SWaM</strong> program, administered by the Virginia
                            Department of Small Business and Supplier Diversity (SBSD). SWaM certification
                            verifies eligible small, women-owned, and/or minority-owned businesses and
                            supports participation in state-funded procurement and supplier-diversity
                            initiatives across Virginia agencies, public universities, and many localities.
                        </p>
                        <p>
                            As a SWaM-certified Virginia company, ERI is positioned to support Commonwealth
                            and local government customers seeking qualified small-business partners for
                            engineering, research and development, and technology solutions.
                        </p>
                        <p className="certifications__link">
                            <a
                                href="https://sbsd.virginia.gov/small-business-certification/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Learn more about Virginia SWaM (SBSD)
                            </a>
                        </p>
                    </div>
                </div>
            </section>

            <section id='team-members' className="team__section see__pad p_relative">
                <div className="pattern-layer">
                    <div className="pattern-3 p_absolute" data-parallax='{"y": 50}' style={{ backgroundImage: `url(${shape4})` }}></div>
                </div>
                <div className="auto-container">
                    <div className="title__data">
                        <div className="sub__title">
                            <h4>Team Members</h4>
                        </div>
                    </div>
                    <div className="row">
                        {teamData.map((item, id) => (
                            <div className="col-lg-4 col-md-6 col-sm-12 mb-4 mt-4" key={id}>
                                <div className="team__block wow fadeInUp animated" data-wow-delay={item.data_aos_delay} data-wow-duration="1500ms">
                                    <div className="team__img">
                                        <figure>
                                            <img src={item.image} alt="" />
                                        </figure>
                                    </div>
                                    <div className="team__name">
                                        <h3>{item.name}</h3>
                                    </div>
                                    <div>
                                        <h5 className="team__role">{item.role}</h5>
                                    </div>
                                    <div className="team__media">
                                        <ul>
                                            {/* <li><Link to="#">FB.</Link></li>
                                        <li><Link to="#">TW.</Link></li> */}
                                            <li><Link to={`${item.linkedin}`} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={item.linkedin.includes("linkedin.com/in/") ? faLinkedin : faGlobe} size='lg' /></Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="title__data" style={{ marginTop: '60px' }}>
                        <div className="sub__title">
                            <h4>Former Team Members</h4>
                        </div>
                    </div>
                    <div className="row">
                        {formerTeamData.map((item, id) => (
                            <div className="col-lg-4 col-md-6 col-sm-12 mb-4 mt-4" key={id}>
                                <div className="team__block wow fadeInUp animated" data-wow-delay={item.data_aos_delay} data-wow-duration="1500ms">
                                    <div className="team__img">
                                        <figure>
                                            <img src={item.image} alt="" />
                                        </figure>
                                    </div>
                                    <div className="team__name">
                                        <h3>{item.name}</h3>
                                    </div>
                                    <div>
                                        <h5 className="team__role">{item.role}</h5>
                                    </div>
                                    <div className="team__media">
                                        <ul>
                                            <li><Link to={`${item.linkedin}`} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={item.linkedin.includes("linkedin.com/in/") ? faLinkedin : faGlobe} size='lg' /></Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section id='partners' name='partners' className="team__section see__pad p_relative" style={{ paddingTop: '0px' }}>
                <div className="pattern-layer">
                    <div className="pattern-3 p_absolute" data-parallax='{"y": 50}' style={{ backgroundImage: `url(${shape4})` }}></div>
                </div>
                <div className="auto-container">
                    <div className="title__data">
                        <div className="sub__title">
                            <h4><br/>HR & Legal</h4>
                        </div>
                    </div>
                    <div className="row">
                        {partnersData.map((item, id) => (
                            <div className="col-lg-3 col-md-6 col-sm-12" key={id}>
                                <div className="team__block wow fadeInUp animated" data-wow-delay={item.data_aos_delay} data-wow-duration="1500ms">
                                    <div className="team__img">
                                        <figure>
                                            <img src={item.image} alt="" />
                                        </figure>
                                    </div>
                                    <div className="team__name">
                                        <h3>{item.name}</h3>
                                    </div>
                                    <div>
                                        <h5 className="team__role">{item.role}</h5>
                                    </div>
                                    <div className="team__media">
                                        <ul>
                                            {/* <li><Link to="#">FB.</Link></li>
                                        <li><Link to="#">TW.</Link></li> */}
                                            <li><Link to={`${item.linkedin}`} target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={item.linkedin.includes("linkedin.com/in/") ? faLinkedin : faGlobe} size='lg' /></Link></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section id='founder'>
                <Pride></Pride>
            </section>

            <section id='gallery'>
                <Gallery></Gallery>
            </section>
            {/* <section className="pricing__section see__pad p_relative">
            <div className="pattern-layer">
                <div className="pattern-4 p_absolute" data-parallax='{"x": 100}' style={{ backgroundImage: `url(${shape3})` }}></div>
            </div>  
            <div className="auto-container">
                <div className="title__data">
                    <div className="sub__title">
                        <h4>Pricing</h4>
                    </div>
                    <div className="title">
                        <h2>Product Price</h2>
                    </div>
                </div>
                <div className="row">
                    {pricingData.map((item, id)=>(
                        <div className="col-lg-4 col-md-6 col-sm-12 wow fadeInUp animated" data-wow-delay={item.delay} data-wow-duration="1500ms" key={id}>
                            <div className="price__content p_relative">
                                <div className="price__data">
                                    <h5>{item.price_name}</h5>
                                    <h4><span>$</span>{item.amount} / <span>{item.time}</span></h4>
                                </div>
                                <div className="price__block">
                                    <div className="price__list">
                                        <ul>
                                            <li>{item.list_a}</li>
                                            <li>{item.list_b}</li>
                                            <li>{item.list_c} </li>
                                            <li>{item.list_d}</li>
                                            <li>{item.list_e}</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="price__icon">
                                    <i className="icon-16"></i>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section> */}
            <FooterOne></FooterOne>
        </>
    );
};

export default About;